module.exports = __webpack_public_path__ + "static/media/Sketch8.59eff1aa.jpeg";